import { Badge } from '@winnin/winnin_ui.components.badge'
import { TooltipWithPortal } from '@winnin/winnin_ui.components.tooltip-with-portal'

import { useTranslate } from 'lib/tolgee'

const TOLGEE_PREFIX = 'ZaiTag'

export default function ZaiTag({ children = 'Zai' }) {
  const t = useTranslate()

  return (
    <TooltipWithPortal
      tooltipMessage={t({
        key: `${TOLGEE_PREFIX}-tooltipMessage-asDashboard`,
        defaultValue: 'Esse dashboard tem um report automático criado pela Zai, nossa AI',
      })}
    >
      <Badge colorScheme="zai">{children}</Badge>
    </TooltipWithPortal>
  )
}
